package one.healthium.content.navigation.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.insights.ui.content.ContentScreen

@Composable
fun ContentContent(component: ContentComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        ContentScreen(contentOptions = component.options, eventDelegate = component)
    }
}